export class Color {
	constructor(idColor, description, hexColor) {
		this.idColor = idColor;
		this.description = description;
		this.hex = hexColor;
	}
}
